import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import SearchExperience from "@/components/SearchExperience";
import SEOHead from "@/components/SEOHead";
import Breadcrumbs from "@/components/Breadcrumbs";
import { breadcrumbLd, itemListLd, titleCase } from "@/lib/seo";
import { MapPin } from "lucide-react";

export default function StatePage() {
  const { slug } = useParams();
  const [name, setName] = useState(titleCase(slug));
  const [cities, setCities] = useState([]);

  useEffect(() => {
    setName(titleCase(slug));
    setCities([]);
    api.get("/states").then((r) => {
      const m = (r.data.states || []).find((s) => s.slug === slug);
      if (m) setName(m.name);
    }).catch(() => {});
    api.get(`/cities?state=${slug}`).then((r) => setCities(r.data.cities || [])).catch(() => {});
  }, [slug]);

  const path = `/state/${slug}`;
  const crumbs = [{ name: "Home", path: "/" }, { name: name, path }];
  const jsonLd = [
    breadcrumbLd(crumbs),
    cities.length ? itemListLd(`Cities in ${name}`, cities.map((c) => ({ name: c.name, path: `/city/${c.slug}` }))) : null,
  ].filter(Boolean);

  return (
    <>
      <SEOHead
        title={`Colleges in ${name} — Admissions & Courses`}
        description={`Explore top colleges across ${name}. Browse by city, compare options and get free admission guidance.`}
        canonicalPath={path}
        jsonLd={jsonLd}
      />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-6">
        <Breadcrumbs items={crumbs} />
        {cities.length > 0 && (
          <div className="mt-4" data-testid="state-cities-links">
            <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-400">Browse by city</p>
            <div className="flex flex-wrap gap-2">
              {cities.map((c) => (
                <Link key={c.slug} to={`/city/${c.slug}`} data-testid={`city-link-${c.slug}`} className="inline-flex items-center gap-1 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 hover:border-[#0B2A6B]/40 hover:text-[#0B2A6B]">
                  <MapPin className="h-3 w-3" /> {c.name} <span className="text-slate-400">({c.colleges})</span>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
      <SearchExperience
        key={slug}
        lockedFilters={{ state: slug }}
        hideStateFacet
        title={`Colleges in ${name}`}
        subtitle={`Browse and filter institutions across ${name}.`}
      />
    </>
  );
}
